var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repeatability props-group"},[_c('el-form-item',{attrs:{"label":"重复性校验"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.repeatability),callback:function ($$v) {_vm.$set(_vm.component.properties, "repeatability", $$v)},expression:"component.properties.repeatability"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a064b64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/repeatability.vue
// module id = null
// module chunks = 